export default (limit, event) => {

  const files = event.target.files || event.dataTransfer.files

  if (files.length <= limit) return true

  alert(`${limit}つ以上のファイルは選択できません。`)
  event.currentTarget.value = ''
  return false

}
